<template>
  <v-layout>
    <DataTableFixedHeader
      :columns="visibleColumns"
      :groups="groups"
      :fixed-header="true"
      :table-height="blockHeight"
      :is-familiarized-show="isFamiliarizedShow"
      :loading="loading"
    >
      <template v-slot:prepend-cell="shipping">
        <div>
          <v-tooltip
            v-if="shipping.item.phaseType.id === phaseTypes.COMBINATION"
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon
                style="color: rgba(0,0,0,.26)!important"
                v-on="on"
              >
                more_vert
              </v-icon>
            </template>
            <span>
              Звенья Свозка запрещено добавлять в маршрут
            </span>
          </v-tooltip>
          <v-menu
            v-else
            :nudge-width="200"
            offset-x
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                icon
                :disabled="
                  shipping.item.phaseType.id === phaseTypes.COMBINATION &&
                    !shipping.item.route &&
                    !shipping.item.draft
                "
                v-on="on"
              >
                <v-icon style="color: rgba(0,0,0,.26)!important">
                  more_vert
                </v-icon>
              </v-btn>
            </template>
            <v-list
              v-if="shipping.item.inCar"
              style="max-height:165px;overflow-y:auto;overflow-x:hidden;"
            >
              <v-list-tile>
                <v-list-tile-title>
                  <v-layout align-center>
                    <v-icon
                      small
                      outline
                      color="grey lighnen-1"
                      class="mr-1"
                    >
                      info
                    </v-icon>
                    <span>Поставка в машине</span>
                  </v-layout>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
            <v-list
              v-else-if="
                shipping.item.phaseType.id !== phaseTypes.COMBINATION &&
                  !shipping.item.route &&
                  !shipping.item.draft
              "
              style="max-height:165px;overflow-y:auto;overflow-x:hidden;"
            >
              <v-list-tile @click="addPhase(null, shipping.item)">
                <v-list-tile-title>Новый</v-list-tile-title>
              </v-list-tile>
              <template v-for="(route, index) in planningRoutes">
                <v-list-tile
                  :key="index + 'route'"
                  @click="addPhase(route, shipping.item)"
                >
                  <v-list-tile-title>{{ route.title }}</v-list-tile-title>
                </v-list-tile>
              </template>
            </v-list>
            <v-list
              v-else-if="
                (shipping.item.phaseType.id !== phaseTypes.COMBINATION &&
                  shipping.item.route) ||
                  (shipping.item.phaseType.id !== phaseTypes.COMBINATION &&
                    shipping.item.draft)
              "
              style="max-height:165px;overflow-y:auto;overflow-x:hidden;"
            >
              <v-list-tile @click="removePhase(true, shipping.item)">
                <v-list-tile-title>К распределению</v-list-tile-title>
              </v-list-tile>
              <template v-for="(route, index) in planningRoutes">
                <v-list-tile
                  v-if="
                    shipping.item.route
                      ? shipping.item.route.title !== route.title
                      : shipping.item.draft
                        ? shipping.item.draft.title !== route.title
                        : false
                  "
                  :key="index"
                  @click="movePhaseToRoute(route, shipping.item)"
                >
                  <v-list-tile-title>{{ route.title }}</v-list-tile-title>
                </v-list-tile>
              </template>
            </v-list>
            <v-list
              v-else-if="
                (shipping.item.phaseType.id === phaseTypes.COMBINATION &&
                  shipping.item.route) ||
                  (shipping.item.phaseType.id === phaseTypes.COMBINATION &&
                    shipping.item.draft)
              "
              style="max-height:165px;overflow-y:auto;overflow-x:hidden;"
            >
              <v-list-tile @click="removePhase(true, shipping.item)">
                <v-list-tile-title>К распределению</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template v-slot:checkbox-cell="shipping">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-checkbox
              v-model="shipping.item.isFamiliarized"
              hide-details
              @mouseover="detailItemFamiliarized(shipping.item.phaseId)"
              @mouseleave="itemFamiliarized = ''"
              v-on="on"
              @change="changeShippingFamiliarized(shipping.item, true)"
            />
          </template>
          <span>
            {{ itemFamiliarized }}
          </span>
        </v-tooltip>
      </template>
    </DataTableFixedHeader>
    <v-layout
      style="position: fixed; bottom: 0; right: 0; z-index: 4"
      class="ma-2"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            color="grey lighten-3"
            fab
            class="font-weight-bold title ma-0"
            v-on="on"
          >
            <span class="grey--text text--darken-1 font-weight-bold">?</span>
          </v-btn>
        </template>
        <span>
          Условия попадания Поставки в Планирование маршрутов по направлению:
          <br>1) Поставки с типом “Импорт в Украину“ и “Поставка за пределами
          Украины“. <br>2) У Поставки есть звено со способом доставки:
          "Свозка" или "Заезд". <br>3) Звено из п.2 является текущим или
          следующим за текущим. <br>4) Звено из п.2 выполняется не транспортом
          клиента.
          <br>
          <br>Условия попадания Маршрута в Планирование маршрутов: <br>1)
          Маршруты, только в статусе Собирает/Склад.
        </span>
      </v-tooltip>
      <DataColumnsSettings
        :columns="columns"
        resource="routePlanning"
        :flat-settings-button="false"
        color-settings-button="grey lighten-3"
        icon-color-settings-button="grey darken-1"
        :is-top-position-settings-button="true"
      />
    </v-layout>
  </v-layout>
</template>

<script>
import DataTableFixedHeader from "./DataTableFixedHeader.vue";
import DataColumnsSettings from "../../../components/data-list/ColumnsSettings.vue";
import * as routesPlanningApi from "../../../backend/routesPlanningApi.js";
import * as routesApi from "../../../backend/routesApi.js";
import auth from "../../../auth.js";
import { userRoles } from "../../../enums/user-roles.js";
import { ePhaseTypes } from "../../shippings/components/phases/shipping-phase-types.js";

export default {
  components: {
    DataTableFixedHeader,
    DataColumnsSettings,
  },
  props: ["blockHeight"],
  data() {
    return {
      itemFamiliarized: "",
      groups: ["region", "district", "city", "postcode"],
      isFamiliarizedShow: false,
      loading: false,
    };
  },
  computed: {
    headers() {
      const columns = this.$store.getters["routePlanning/headers"];
      if (!this.isFamiliarizedShow) {
        return columns.filter(c => {
          return c.name != "isFamiliarized" || !c.hidden;
        });
      }
      return columns.filter(c => !c.hidden);
    },
    planningData() {
      return this.$store.getters["routePlanning/getPlanningData"];
    },
    planningRoutes() {
      return this.$store.getters["routePlanning/planningRoutes"];
    },
    routesColors() {
      return this.$store.getters["routePlanning/routesColors"];
    },
    shippingsLoading() {
      return this.$store.getters["routePlanning/shippingsLoading"];
    },
    columnsSettings() {
      return this.$store.getters["routePlanning/columns"];
    },
    visibleColumns() {
      const columns = JSON.parse(JSON.stringify(this.headers));
      columns.forEach(c => {
        const column = this.columnsSettings.find(sc => sc.name === c.name);
        if (column) {
          c.visible = column.visible;
          c.order = column.order;
        }
      });
      columns.sort((a, b) => {
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.headers.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.headers.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      return columns.filter(c => c.visible);
    },
    phaseTypes() {
      return ePhaseTypes;
    },
    columns() {
      const columns = JSON.parse(JSON.stringify(this.headers));
      columns.forEach(c => {
        c.visible = true;
        c.order = 0;
      });
      return columns.filter(
        c => c.title && c.type !== "icon" && c.type !== "checkbox",
      );
    },
  },
  created() {
    this.isFamiliarizedShow = !!auth
      .getUser()
      .roles.find(r => r.id === userRoles.Logist || r.id === userRoles.Admin);
  },
  methods: {
    async addPhase(route, phase) {
      if (phase.phaseType.id === this.phaseTypes.COMBINATION) {
        return;
      }
      const phases = [...this.planningData];
      let message = "";
      this.loading = true;

      if (route === null) {
        const newDraft = await routesPlanningApi.createRouteDraft(
          phase.shipping.id,
          phase.phaseId,
          phase.direction.id,
        );

        phases.forEach(i => {
          if (i.phaseId === phase.phaseId) {
            i.routeColor = this.getColor(
              newDraft.number.replace(/\D+/g, "") - 1,
            );
            i.draft = { id: newDraft.id, title: `${newDraft.number}(n)` };
            i.isFamiliarized = true;
          }
        });
        message = `Звено добавлено в черновик маршрута ${newDraft.number}(n)`;
      } else if (!route.phases.find(item => item.phaseId === phase.phaseId)) {
        if (route.routeId && !route.draftId) {
          const routeItemId = await routesApi.addRouteItems(route.routeId, [
            phase.phaseId,
          ]);
          phases.forEach(i => {
            if (i.phaseId === phase.phaseId) {
              i.routeColor = route.routeColor;
              i.route = { id: route.routeId, title: route.title };
              i.routeItemId = routeItemId[0];
              i.draft = null;
              i.isFamiliarized = true;
            }
          });
          message = `Звено перемещено в маршрут ${route.title}`;
        } else if (route.draftId) {
          await routesPlanningApi.updateRouteDraft(
            route.draftId,
            phase.phaseId,
          );

          phases.forEach(i => {
            if (i.phaseId === phase.phaseId) {
              i.routeColor = route.routeColor;
              i.draft = { id: route.draftId, title: route.title };
              i.route = null;
              i.isFamiliarized = true;
            }
          });
          message = `Звено перемещено в маршрут ${route.title}`;
        }
      }

      if (!phase.isFamiliarized) {
        this.$store.commit("routePlanning/setChangedItemRow", true);
        await this.changeShippingFamiliarized(phase, false);
      }
      this.$store.commit("routePlanning/setChangedItemRow", true);
      await this.$store.dispatch("routePlanning/getPlanningRoutes");
      this.$store.commit("routePlanning/setChangedItemRow", true);
      this.$store.commit("routePlanning/setPlanningData", phases);
      this.showInfo(message);
      this.loading = false;
    },
    getColor(routeIndex) {
      let diff = +routeIndex;
      while (diff > this.routesColors.length - 1) {
        diff = diff - (this.routesColors.length - 1);
      }
      return this.routesColors[diff];
    },
    getRouteSummaryInformation(shippings) {
      let weight = 0;
      let volume = 0;
      let cargoPlaces = 0;

      if (shippings) {
        shippings.forEach(shipping => {
          weight += shipping.weight;
          volume += shipping.volume;
          cargoPlaces += shipping.cargoPlaces;
        });
      }
      return { weight, volume, cargoPlaces };
    },
    async removePhase(isReload, phase) {
      this.loading = true;
      const phases = [...this.planningData];
      if (phase.route) {
        await routesApi.deleteItem(phase.route.id, phase.routeItemId);
        if (isReload) {
          phases.forEach(i => {
            if (i.phaseId === phase.phaseId) {
              i.routeColor = "";
              i.route = null;
              i.routeItemId = null;
            }
          });
          this.$store.commit("routePlanning/setChangedItemRow", true);
          await this.$store.dispatch("routePlanning/getPlanningRoutes");
          this.$store.commit("routePlanning/setChangedItemRow", true);
          this.$store.commit("routePlanning/setPlanningData", phases);
          this.showInfo("Звено удалено с маршрута");
        }
      } else if (phase.draft) {
        await routesPlanningApi.deleteShippingFromRouteDraft(
          phase.draft.id,
          phase.phaseId,
        );
        if (isReload) {
          phases.forEach(i => {
            if (i.phaseId === phase.phaseId) {
              i.routeColor = "";
              i.draft = null;
            }
          });
          this.$store.commit("routePlanning/setChangedItemRow", true);
          await this.$store.dispatch("routePlanning/getPlanningRoutes");
          this.$store.commit("routePlanning/setChangedItemRow", true);
          this.$store.commit("routePlanning/setPlanningData", phases);
          this.showInfo("Звено удалено с маршрута");
        }
      }
      this.loading = false;
    },
    async movePhaseToRoute(route, phase) {
      await this.removePhase(false, phase);
      await this.addPhase(route, phase);
    },
    async changeShippingFamiliarized(shipping, isReload) {
      await routesPlanningApi.changeShippingPhaseFamiliarized(shipping.phaseId);
      if (!isReload) {
        return;
      }
      const planningItems = this.planningData;
      planningItems.forEach(i => {
        if (i.phaseId === shipping.phaseId) {
          i.isFamiliarized = !i.isFamiliarized;
        }
      });
      this.$store.commit("routePlanning/setPlanningData", planningItems);
      this.$store.commit("routePlanning/setChangedItemRow", true);
    },
    async detailItemFamiliarized(phaseId) {
      const detailItem = await routesPlanningApi.getItemFamiliarized(phaseId);
      if (detailItem) {
        this.itemFamiliarized = `Автор: ${
          detailItem.user
        }; Дата: ${this.$options.filters.date(detailItem.date)}`;
      } else {
        this.itemFamiliarized = "Отметку Ознакомлен еще никто не менял";
      }
    },
  },
};
</script>
